import React from 'react';
import '../../../assets/css/common/video/index.css';
import {request} from '../../../assets/js/libs/request.js';
import config from '../../../assets/js/conf/config.js';

export default  class Videorecom extends React.Component {
	constructor(props) {
	    super(props)
	    let merchand = props.location.state !== undefined?props.location.state.merchand:JSON.parse(localStorage['merchand']);
	    this.state = {
	    	data: {
	    		"type": 1,
	    		"merchandiseId": merchand.merchandiseId
	    	},
			fenyuanArr: []
	    }
	}
	componentDidMount(props) {
		this.getJson();
	}
	getJson(){
		request(config.baseUrl+'api/Study/S026', "post", this.state.data).then(res=>{
			if(res.code == 0){
		    	this.setState({
		    		fenyuanArr: res.data
		    	})
		    }
		});
	}
	componentWillUnmount(){
    	//界面离开的时候
		this.setState = (state, callback)=>{
			return;
		}
	}
	LeftIcon(path){
		this.props.history.replace("/transfer");
		setTimeout(()=>{
		    this.props.history.replace(path)
		},10);
	}
	recomNavSpanClick(num){
		let data = this.state.data;
		data.type = num;
		this.setState({
			data: data
		})
		this.getJson();
	}
	render() {
		return(
			<div className={'recom'}>
				<div className={'found'} style={{marginTop: '0'}}>
					<div className={'recomNav'}>
						<div>
							<span className={this.state.data.type == 1?'on':''} onClick={this.recomNavSpanClick.bind(this, 1)}>知识商品</span>
							<span className={this.state.data.type == 2?'on':''} onClick={this.recomNavSpanClick.bind(this, 2)}>实物商品</span>
						</div>
					</div>
					<div className={'found-title-wrap'}>
					{
						this.state.fenyuanArr.length>0?
						this.state.fenyuanArr.map((item2,index2) => {
							return(
								<div className={'found-item0 col'} onClick={this.LeftIcon.bind(this, '/video/other?olId='+item2.id)} key={index2}>
									<div className={'found-img0'}>
										<img src={item2.logo != ""?item2.logo:require('../../../assets/images/video/pic_cover.png')} />
									</div>
									<div className={'found-txt'}>
										<div className={'found-title0'}>{item2.name}</div>
										<div className={"found-text0"}>{item2.liveBegin}</div>
										<div className={"found-text0"}>{item2.type == 1?'直播课':item2.type == 2?"视频":"语音"} | {item2.liveSpan}分钟</div>
									</div>
								</div>
							)
						})
						:<div className={"null"}>
							<img src={require('../../../assets/images/video/wu.png')} />
							<div>暂无内容!</div>
						</div>
					}
					<div style={{height: 1.5+'rem'}}></div>
						
					</div>
				</div>
		    </div>
		);
	}
}